<template>
    <v-container fluid class="ma-1 pa-2">
        <search-toolbar title="TecDoc" :filter-enabled="false"></search-toolbar>
        <autocomplete v-model="autocomplete" index="tecdoc" :placeholder="$t('message.337')"></autocomplete>
        <results-widget ref="results" index="tecdoc" :link-to-parts="true"></results-widget>
    </v-container>
</template>

<script>

export default {
  name: 'tecdoc',
  data () {
    return {
      loading: false,
      autocomplete: null,
      items: []
    }
  },
  methods: {
  },
  watch: {
    autocomplete (value) {
      this.$log.debug(`TecDoc Search: ${value}`)
      this.$refs.results.search(value)
    }
  }
}
</script>

<style scoped>

</style>
